export enum TransactionCategoryLabelEnum {
  FREIGHT_BOL = 'Freight/BOL',
  DEMURRAGE = 'Demurrage',
  INVOICE_NUMBER = 'Invoice Number',
  BILL_LADING = 'Bill of Lading',
  AWB = 'AWB',
  TERMINAL_FEE = 'Terminal Fee',
  STORAGE = 'Storage',
  CURRENCY_CONVERSION = 'Currency Conversion',
}

export enum TransactionCategoryEnum {
  FREIGHT_BOL = 'FREIGHT_BOL',
  DEMURRAGE = 'DEMURRAGE',
  INVOICE_NUMBER = 'INVOICE_NUMBER',
  BILL_LADING = 'BILL_LADING',
  AWB = 'AWB',
  TERMINAL_FEE = 'TERMINAL_FEE',
  STORAGE = 'STORAGE',
  CURRENCY_CONVERSION = 'CURRENCY_CONVERSION',
}
